import { render, staticRenderFns } from "./StockSlipOpening.vue?vue&type=template&id=e937a2fc&scoped=true"
import script from "./StockSlipOpening.vue?vue&type=script&lang=js"
export * from "./StockSlipOpening.vue?vue&type=script&lang=js"
import style1 from "./StockSlipOpening.vue?vue&type=style&index=1&id=e937a2fc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e937a2fc",
  null
  
)

export default component.exports